export default __webpack_public_path__ + "static/media/flag.5deeb42f.svg";